import * as yup from "yup";

export const schema = yup.object().shape({
  id: yup.string().optional(),
  locationId: yup.string().when("id", {
    is: (id: string) => !id,
    then: yup.string().required(),
    otherwise: yup.string(),
  }),
  // orderNumber: yup.date().nullable().optional(),
  orderCreatedDate: yup.date().nullable().optional(),
});
